module.exports = __webpack_public_path__ + "static/media/10.92407694.JPG";